// extracted by mini-css-extract-plugin
export default {"parameter":"BlVgU","name":"JvUY6","note":"pMwPz"};